const endPointAPI = {
  AUTH: {
    LOGIN: '/login',
  },
  SETTINGS: {
    UPDATE_CLOCKIFY_TOKEN: '/settings/update-clockify-token',
  },
};
export default endPointAPI;
